/* Declare global Renoun object to be used throughout theme scripts. */
var Renoun = {};

function getFoundationBreakpoints() {
  if (!Foundation) {
    return {};
  }

  const sizes = ["small", "medium", "large", "xlarge", "xxlarge"];
  const breakpoints = {};

  sizes.forEach((size, idx) => {
    if (size == "small") {
      return;
    }
    let media = Foundation.MediaQuery.get(size);
    let val = 0;
    if (media) {
      val = parseFloat(media.replace(/^\D+/g, ""));
    } else {
      return;
    }
    val = val * 16 - 1;
    breakpoints[sizes[idx - 1]] = val;
  });

  if (Object.keys(breakpoints).length > 0) {
    return breakpoints;
  }

  return {};
}

Renoun.breakpoints = getFoundationBreakpoints();

/**
 * Events Object Constructor
 *
 * @version 1.0.0
 */
Renoun.Events = {
  prefix: "rc_",
  functions: [],
  onScroll: function (func, ms) {
    if (!func) return;
    ms = ms || 250;
    let funcname = func.name || "anonymous";
    this[this.prefix + funcname] = Renoun.debounce(func, ms, false);

    window.addEventListener("scroll", this[this.prefix + funcname]);
  },
  removeOnScroll: function (func) {
    if (!func) return;
    let funcname = func.name || "anonymous";
    if (this[this.prefix + funcname]) {
      window.removeEventListener("scroll", this[this.prefix + funcname]);
    }
  },
  onWindowResize: function (func, ms) {
    if (!func) return;
    ms = ms || 250;
    let funcname = func.name || "anonymous";
    this[this.prefix + funcname] = Renoun.debounce(func, ms, true);

    window.addEventListener("resize", this[this.prefix + funcname]);
  },
  removeOnWindowResize: function (func) {
    if (!func) return;
    let funcname = func.name || "anonymous";
    if (this[this.prefix + funcname]) {
      window.removeEventListener("resize", this[this.prefix + funcname]);
    }
  },
};

// Returns a function, that, as long as it continues to be invoked, will not
// be triggered. The function will be called after it stops being called for
// N milliseconds. If `immediate` is passed, trigger the function on the
// leading edge, instead of the trailing.
Renoun.debounce = function (func, wait, immediate) {
  var timeout;
  return function () {
    var context = this,
      args = arguments;
    var later = function () {
      timeout = null;
      if (!immediate) func.apply(context, args);
    };
    var callNow = immediate && !timeout;
    clearTimeout(timeout);
    timeout = setTimeout(later, wait);
    if (callNow) func.apply(context, args);
  };
};

/** Helper function to convert NodeLists to Arrays */
Renoun.toArray = function (nodes) {
  return Array.prototype.slice.call(nodes);
};

/**
 * Media monitor init
 */
Renoun.mediaMonitor = function () {
  jQuery("html").attr("data-screen-size", Foundation.MediaQuery.current);
};

Renoun.setHeaderHeightProperty = function () {
  const header = document.querySelector(
    'header[data-header="renoun-child"]',
  ) || { offsetHeight: 0 };
  const wpadminbar = document.querySelector("#wpadminbar") || {
    offsetHeight: 0,
  };
  let bannerHeight = 0;
  document
    .querySelectorAll("#global-banners .global-banner")
    .forEach(function (banner) {
      if (banner.offsetHeight > 0) bannerHeight += banner.offsetHeight;
    });
  document.documentElement.style.setProperty(
    "--header-height",
    `${header.offsetHeight + wpadminbar.offsetHeight + bannerHeight}px`,
  );
};

Renoun.initBlockSliders = function () {
  const sliders = document.querySelectorAll('[data-slider="true"]');

  sliders.forEach((slider) => {
    let options = slider.dataset.sliderOptions;
    if (!options) return;

    options = JSON.parse(options);
    let responsive = [];
    let slidesPerBreakpoint = options.cols;
    let slideCount = "";

    for (const breakpoint in slidesPerBreakpoint) {
      if (
        slidesPerBreakpoint[breakpoint] === 0 &&
        Renoun.breakpoints[breakpoint]
      ) {
        responsive.push({
          breakpoint: Renoun.breakpoints[breakpoint],
          settings: "unslick",
        });
        continue;
      }

      if (slidesPerBreakpoint[breakpoint] > 0) {
        slideCount = slidesPerBreakpoint[breakpoint];

        if (slideCount) {
          if (!options.slidesToShow) {
            options.slidesToShow = Number(slideCount);
          }
          responsive.push({
            breakpoint: Renoun.breakpoints[breakpoint],
            settings: {
              slidesToShow: Number(slideCount),
            },
          });
        }
      }
    }

    if (responsive) options.responsive = responsive;
    delete options.cols;
    delete options.additionalProps;

    if (
      options.arrows &&
      options.arrowPosition &&
      options.arrowPosition == "below"
    ) {
      let container = document.createElement("div");
      container.classList.add("arrows-container");
      slider.insertAdjacentElement("afterend", container);
      slider.classList.add("slick-slider--arrows-bottom");
      options.appendArrows = container;
      delete options.arrowPosition;
    }

    // Breakpoint visibility
    // options.mobileFirst = true;
    jQuery(slider).slick(options);
  });
};

/* Init Function */
Renoun.init = function () {
  Renoun.mediaMonitor();
  Renoun.Events.onWindowResize(Renoun.mediaMonitor, 150);
  Renoun.setHeaderHeightProperty();
  Renoun.Events.onWindowResize(Renoun.setHeaderHeightProperty, 150);
  Renoun.initBlockSliders();
};

if (jQuery) {
  jQuery.fn.notEmpty = function () {
    return this.length !== 0;
  };
  /* jQuery.fn.empty = function () {
    return this.length === 0;
  } */
}

/* ========================================================================
 * DOM-based Routing
 * Based on http://goo.gl/EUTi53 by Paul Irish
 *
 * Only fires on body classes that match. If a body class contains a dash,
 * replace the dash with an underscore when adding it to the object below.
 *
 * .noConflict()
 * The routing is enclosed within an anonymous function so that you can
 * always reference jQuery with $, even when in .noConflict() mode.
 * ======================================================================== */
// export default function Theme($) {
(function ($) {
  // Use this variable to set up the common and page specific functions. If you
  // rename this variable, you will also need to rename the namespace below.
  var RenounJS = {
    // All pages
    common: {
      init: function () {
        // JavaScript to be fired on all pages

        Renoun.init();
      },
      finalize: function () {
        // JavaScript to be fired on all pages, after page specific JS is fired
      },
    },
    // Home page
    home: {
      init: function () {
        // JavaScript to be fired on the home page
      },
      finalize: function () {
        // JavaScript to be fired on the home page, after the init JS
      },
    },
  };

  // The routing fires all common scripts, followed by the page specific scripts.
  // Add additional events for more control over timing e.g. a finalize event
  var UTIL = {
    fire: function (func, funcname, args) {
      var fire;
      var namespace = RenounJS;
      funcname = funcname === undefined ? "init" : funcname;
      fire = func !== "";
      fire = fire && namespace[func];
      fire = fire && typeof namespace[func][funcname] === "function";

      if (fire) {
        namespace[func][funcname](args);
      }
    },
    loadEvents: function () {
      // Fire common init JS
      UTIL.fire("common");

      // Fire page-specific init JS, and then finalize JS
      $.each(
        document.body.className.replace(/-/g, "_").split(/\s+/),
        function (i, classnm) {
          UTIL.fire(classnm);
          UTIL.fire(classnm, "finalize");
        },
      );

      // Fire common finalize JS
      UTIL.fire("common", "finalize");
    },
  };

  // Load Events
  $(document).ready(UTIL.loadEvents);
})(jQuery);
